import { useEffect, useRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { EditStrategyDialogForm } from './EditForm';
import { AddStrategyForm } from './Form';

type Mode = 'create' | 'edit';

interface Props {
  onClose: () => void;
  onUpdate: () => void;
  mode?: Mode;
  strategyId?: string;
  notify?: (msg: string) => void;
}

export function StrategyDialog({ onClose, onUpdate, mode = 'create', strategyId, notify }: Props) {
  const descriptionElementRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const { current: descriptionElement } = descriptionElementRef;
    if (descriptionElement !== null) {
      descriptionElement.focus();
    }
  }, []);

  return (
    <Dialog
      open
      onClose={onClose}
      scroll="paper"
      maxWidth="lg"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      disableEnforceFocus
    >
      <DialogTitle id="scroll-dialog-title" align="center">
        {mode === 'edit' ? 'Редактирование стратегии' : 'Стратегия'}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
          {mode === 'edit' && strategyId ? (
            <EditStrategyDialogForm
              notify={notify || (() => undefined)}
              strategyId={strategyId}
              onUpdate={onUpdate}
              onClose={onClose}
            />
          ) : (
            <AddStrategyForm onUpdate={onUpdate} />
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
